/* VAULT - search.js — modal + predictive */
(function(){
  'use strict';
  if(!window.Vault) return;
  var V = window.Vault;
  var routes = (window.VAULT && VAULT.routes) || {};

  var modal = V.$('[data-search-modal]');
  var input = V.$('[data-search-input]');
  var clearBtn = V.$('[data-search-clear]');
  var results = V.$('[data-search-results]');
  var heading = V.$('[data-results-heading]');
  var searchSeq = 0;
  var activeSearchController = null;

  function openModal(){
    if(!modal || modal.classList.contains('is-open')) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('no-scroll');
    if(V.trapFocus) V._lastFocus = document.activeElement;
    if(input && !input.value.trim()) showDefaultState();
    setTimeout(function(){ if(input) input.focus(); }, 80);
    if(modal._trapHandler) modal.removeEventListener('keydown', modal._trapHandler);
    modal._trapHandler = function(e){
      if(e.key !== 'Tab' || !V.focusables) return;
      var items = V.focusables(modal);
      if(!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    };
    modal.addEventListener('keydown', modal._trapHandler);
  }
  function closeModal(){
    if(!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('no-scroll');
    if(modal._trapHandler){ modal.removeEventListener('keydown', modal._trapHandler); modal._trapHandler = null; }
    if(V.releaseFocus) V.releaseFocus(null);
  }
  document.addEventListener('search:open', openModal);
  document.addEventListener('search:close', closeModal);
  V.on(modal,'click',function(e){ if(e.target === modal) closeModal(); });

  function formatPredictivePrice(value){
    if(value === null || value === undefined || value === '') return '';
    var dollars = parseFloat(value);
    if(isNaN(dollars)) return '';
    return V.formatMoney(Math.round(dollars * 100));
  }

  function renderResults(data, query){
    if(!results) return;
    var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    // Temporary 30th Celebration focus: only 30th Celebration products are suggested.
    products = products.filter(function(p){ return p && p.title && p.title.indexOf('30th Celebration') !== -1; });
    results.replaceChildren();
    if(products.length === 0){
      var wrap = document.createElement('div');
      wrap.className = 'search-modal__empty';
      var msg = document.createElement('p');
      msg.textContent = 'No products match “' + query + '”.';
      wrap.appendChild(msg);
      var firstWord = String(query).trim().split(/\s+/)[0];
      if(firstWord && firstWord.toLowerCase() !== String(query).trim().toLowerCase()){
        var broaden = document.createElement('a');
        broaden.href = (routes.search || '/search') + '?q=' + encodeURIComponent(firstWord) + '&type=product&options%5Bunavailable_products%5D=hide';
        broaden.className = 'search-modal__empty-link';
        broaden.textContent = 'Search for “' + firstWord + '” instead';
        wrap.appendChild(broaden);
      }
      var all = document.createElement('a');
      all.href = (routes.search || '/search') + '?q=' + encodeURIComponent(query) + '&options%5Bunavailable_products%5D=hide';
      all.className = 'search-modal__empty-link';
      all.textContent = 'Search everything for “' + query + '”';
      wrap.appendChild(all);
      results.appendChild(wrap);
      return;
    }
    products.forEach(function(p){
      var a = document.createElement('a');
      a.className = 'search-modal__product';
      a.href = p.url || '#';
      if(p.available === false) a.classList.add('is-unavailable');
      var imgWrap = document.createElement('div');
      imgWrap.className = 'search-modal__product-img';
      var imgSrc = (p.featured_image && p.featured_image.url) || p.image || '';
      if(imgSrc){
        var img = document.createElement('img');
        img.src = imgSrc + (imgSrc.indexOf('?') === -1 ? '?' : '&') + 'width=120';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 48; img.height = 48;
        imgWrap.appendChild(img);
      }
      a.appendChild(imgWrap);
      var info = document.createElement('div');
      info.className = 'search-modal__product-info';
      var title = document.createElement('div');
      title.className = 'search-modal__product-title';
      title.textContent = p.title || '';
      var price = document.createElement('div');
      price.className = 'search-modal__product-price';
      if(p.available === false){
        price.textContent = 'Sold out';
        price.classList.add('search-modal__product-price--sold');
      } else {
        var hasRange = p.price_min != null && p.price_max != null && parseFloat(p.price_min) !== parseFloat(p.price_max);
        var base = (p.price_min != null) ? p.price_min : p.price;
        var formatted = formatPredictivePrice(base);
        price.textContent = formatted ? (hasRange ? 'From ' + formatted : formatted) : '';
      }
      info.appendChild(title);
      info.appendChild(price);
      a.appendChild(info);
      results.appendChild(a);
    });
  }

  var predictiveEnabled = !(window.VAULT && VAULT.settings && VAULT.settings.predictiveSearch === false);
  var defaultPanel = V.$('[data-search-default]');

  function cancelPendingSearch(){
    searchSeq++;
    if(activeSearchController){
      try { activeSearchController.abort(); } catch(e){}
      activeSearchController = null;
    }
  }
  function showDefaultState(){
    cancelPendingSearch();
    if(results){ results.replaceChildren(); results.setAttribute('aria-busy','false'); }
    if(defaultPanel) defaultPanel.hidden = false;
    if(heading) heading.textContent = 'Try searching for';
  }
  function showResultsState(query){
    if(defaultPanel) defaultPanel.hidden = true;
    if(heading) heading.textContent = 'Results for "' + query + '"';
  }

  var doSearch = V.debounce(function(query){
    if(!predictiveEnabled) return;
    if(!query || query.length < 2){ showDefaultState(); return; }
    cancelPendingSearch();
    var seq = searchSeq;
    var controller = ('AbortController' in window) ? new AbortController() : null;
    activeSearchController = controller;
    showResultsState(query);
    if(results) results.setAttribute('aria-busy','true');
    var url = (routes.predictiveSearch || '/search/suggest.json') +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[options][unavailable_products]=hide' +
      '&resources[limit]=6';
    fetch(url, {headers:{'Accept':'application/json'}, signal: controller ? controller.signal : undefined})
      .then(function(r){ if(!r.ok) throw new Error('Search request failed'); return r.json(); })
      .then(function(data){
        if(seq !== searchSeq) return;
        activeSearchController = null;
        if(results) results.setAttribute('aria-busy','false');
        renderResults(data, query);
      })
      .catch(function(err){
        if(err && err.name === 'AbortError') return;
        if(seq !== searchSeq) return;
        activeSearchController = null;
        if(!results) return;
        results.setAttribute('aria-busy','false');
        results.replaceChildren();
        var p = document.createElement('p');
        p.className = 'text-mute';
        p.style.cssText = 'font-size:13px;padding:8px 0;';
        p.textContent = 'Search is unavailable right now. Press Enter to search the full store.';
        results.appendChild(p);
      });
  }, 220);

  V.$$('[data-header-search-input]').forEach(function(headerInput){
    var handoff = function(){
      if(!modal) return;
      if(!modal.classList.contains('is-open')) openModal();
      if(input){
        input.value = headerInput.value;
        if(clearBtn) clearBtn.hidden = !headerInput.value.trim();
        doSearch(headerInput.value.trim());
      }
    };
    V.on(headerInput, 'focus', handoff);
    V.on(headerInput, 'input', handoff);
  });

  V.on(input,'input',function(){
    var v = this.value.trim();
    if(clearBtn) clearBtn.hidden = !v;
    doSearch(v);
  });

  if(clearBtn){
    V.on(clearBtn,'click',function(){
      if(!input) return;
      input.value = '';
      clearBtn.hidden = true;
      input.focus();
      showDefaultState();
    });
  }
})();
